import React, { useMemo } from 'react';

import { BingoScheduler } from './components/BingoScheduler';
import { Detailed } from './components/Detailed';
import { DetailedWithTitle } from './components/DetailedWithTitle';
import { InPageMenuItem } from './components/InPageMenuItem';
import { MenuItem } from './components/MenuItem';
import { Title } from './components/Title';

import { Loader } from 'js/components/common/Loader';
import { usePortletConfig } from 'js/components/system/Portlet';

import { TSkeletonConfig, TSkeletonProps } from '@interlayer/js/app/components/main/Skeleton/types';

import { SKELETON_TYPES } from './constants';

import style from './Skeleton.scss';

const Components = {
    [SKELETON_TYPES.bingoScheduler]: BingoScheduler,
    [SKELETON_TYPES.detailed]: Detailed,
    [SKELETON_TYPES.allCategory]: DetailedWithTitle,
    [SKELETON_TYPES.inline]: DetailedWithTitle,
    [SKELETON_TYPES.menuItem]: MenuItem,
    [SKELETON_TYPES.inPageMenuItem]: InPageMenuItem,
    [SKELETON_TYPES.title]: Title
};

export const Skeleton: React.FC<TSkeletonProps> = ({ configuration } = {}) => {
    const { skeletonConfiguration } = usePortletConfig() as { skeletonConfiguration: TSkeletonConfig[] };
    const skeletons = useMemo(
        () => (configuration || skeletonConfiguration)?.filter(({ type }) => SKELETON_TYPES[type]) || []
        , [configuration, skeletonConfiguration]
    );

    if (!skeletons?.length) {
        return (
            <div className={style.defaultWrapper}>
                <Loader className={style.defaultLoader} />
            </div>
        );
    }

    return (
        <>
            {skeletons.map((item, index) => {
                const Component = Components[item.type];

                return (
                    <Component
                        key={`${item.type}_${index}`}
                        {...item}
                    />
                );
            })}
        </>
    );
};
